<!--评价等级-->
<template>
  <div style="min-height: 350px">
    <div class="header">
      <a-button @click="modelForm.visible = true" icon="plus" type="primary">添加评价等级</a-button>
    </div>
    <div style="overflow: auto">
      <a-table
        style="min-width: 800px"
        :columns="columns"
        rowKey="id"
        :scroll="{ y: 350 }"
        :pagination="tableRelevant.tablePagination"
        :loading="tableRelevant.tableLoading"
        :locale="tableRelevant.locale"
        :dataSource="tableRelevant.tableDataSource"
      >
        <span slot="minScore" slot-scope="text">
          {{ text.minScore + (text.minScoreIsOpen ? '（包含当前值）' : '（不包含当前值）') }}
        </span>
        <span slot="maxScore" slot-scope="text">
          {{ text.maxScore + (text.maxScoreIsOpen ? '（包含当前值）' : '（不包含当前值）') }}
        </span>
        <span slot="abilityType" slot-scope="text">
          {{ text === 0 ? '能力类型' : '能力等级' }}
        </span>
        <span slot="status" slot-scope="text">
          <a-switch @change="tableStatusChange(text)" v-model="text.enabled" checked-children="启用" un-checked-children="禁用" />
        </span>
        <div slot="action" slot-scope="text">
          <a @click="edit(text)" style="margin-right: 10px" href="javaScript:;">
            <a-icon type="edit" />
            编辑</a
          >
          <a-popconfirm title="确认删除此评价等级？" @confirm="del(text)">
            <a style="color: red" href="javaScript:;">
              <a-icon type="delete" />
              删除</a
            >
          </a-popconfirm>
        </div>
      </a-table>
    </div>

    <!--添加/编辑能力体系-->
    <a-modal
      v-model="modelForm.visible"
      :centered="true"
      :destroyOnClose="true"
      :title="modelForm.title"
      :confirm-loading="modelForm.confirmLoading"
      @cancel="modelFormCancel"
      @ok="modelFormOk"
      width="800px"
    >
      <a-form-model ref="myModelForm" style="max-height: 400px; overflow-y: auto" :labelCol="{ span: 6 }" :wrapperCol="{ span: 16 }" :model="modelForm.data" :rules="modelForm.rules">
        <a-form-model-item label="评价等级" prop="abilityLevel">
          <a-input v-model="modelForm.data.abilityLevel" placeholder="请输入评价等级" />
        </a-form-model-item>
        <a-form-model-item label="等级名称" prop="abilityLevelName">
          <a-input v-model="modelForm.data.abilityLevelName" placeholder="请输入等级名称" />
        </a-form-model-item>
        <a-form-model-item label="能力类型" prop="abilityType">
          <a-select v-model="modelForm.data.abilityType" placeholder="请选择能力类型">
            <a-select-option :value="0">能力类型</a-select-option>
            <a-select-option :value="1">能力等级</a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="levelExpression" prop="levelExpression">
          <a-input v-model="modelForm.data.levelExpression" placeholder="请输入表达式" />
        </a-form-model-item>
        <a-form-model-item label="状态">
          <a-radio-group v-model="modelForm.data.enabled">
            <a-radio :value="true">启用</a-radio>
            <a-radio :value="false">禁用</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="等级说明" prop="description">
          <a-textarea v-model="modelForm.data.description" placeholder="请输入等级说明" :auto-size="{ minRows: 3, maxRows: 5 }" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'

const columns = [
  {
    title: '评价等级',
    dataIndex: 'abilityLevel',
  },
  {
    title: '等级名称',
    dataIndex: 'abilityLevelName',
  },
  {
    title: '等级说明',
    dataIndex: 'description',
    ellipsis: true,
  },
  {
    title: '能力等级类型',
    dataIndex: 'abilityType',
    scopedSlots: { customRender: 'abilityType' },
  },
  {
    title: 'levelExpression',
    dataIndex: 'levelExpression',
  },
  // {
  //   title: '最小值',
  //   width: 180,
  //   scopedSlots: { customRender: 'minScore' },
  // },
  // {
  //   title: '最大值',
  //   width: 190,
  //   scopedSlots: { customRender: 'maxScore' },
  // },
  {
    title: '状态',
    width: 100,
    scopedSlots: { customRender: 'status' },
  },
  {
    title: '操作',
    scopedSlots: { customRender: 'action' },
  },
]

export default {
  name: 'AbilitySystemGrade',
  props: {
    abilitySystemGradeId: '',
  },
  data() {
    return {
      columns,
      //表格相关
      tableRelevant: tableRelevant.call(this),
      modelForm: {
        visible: false,
        confirmLoading: false,
        title: '添加评价等级',
        data: {
          id: undefined,
          abilityLevel: '',
          abilityLevelName: '',
          abilityType: undefined,
          minScore: undefined,
          minScoreIsOpen: 'true',
          maxScore: undefined,
          maxScoreIsOpen: 'true',
          enabled: true,
          description: '',
          levelExpression: '',
        },
        rules: {
          levelExpression: [{ required: true, message: '请输入内容', trigger: 'blur' }],
          abilityLevel: [{ required: true, message: '请输入评价等级', trigger: 'blur' }],
          abilityLevelName: [
            { required: true, message: '请输入等级名称', trigger: 'blur' },
            { min: 2, max: 30, message: '等级名称长度为 2 到 30个字符', trigger: 'blur' },
          ],
          abilityType: [{ required: true, message: '请选择能力等级类型', trigger: 'change' }],
          minScore: [{ required: true, message: '请输入最小值', trigger: 'blur' }],
          maxScore: [{ required: true, message: '请输入最大值', trigger: 'blur' }],
          description: [{ required: true, message: '请输入等级说明', trigger: 'blur' }],
        },
      },
    }
  },
  mounted() {
    this.getPageList()
  },
  methods: {
    //获取评价等级列表
    getPageList(pageIndex) {
      this.tableRelevant.tableLoading = true
      const params = {
        AbilityEvaluationSysId: this.abilitySystemGradeId,
        pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
      }
      this.$http.ReportService.getAbilityLevelConfig(params)
        .then((res) => {
          const { data } = res
          this.tableRelevant.tableDataSource = data.items
          this.tableRelevant.tablePagination.total = data.totalCount
        })
        .finally(() => {
          this.tableRelevant.tableLoading = false
        })
    },

    //评价等级状态切换
    tableStatusChange(val) {
      this.$message.destroy()
      this.tableRelevant.tableLoading = true
      this.$http.ReportService.statusAbilityLevelConfig(val.id)
        .then((res) => {
          const { message } = res
          this.$message.success(message)
        })
        .catch(() => {
          val.enabled = !val.enabled
          this.$message.error(message)
        })
        .finally(() => {
          this.tableRelevant.tableLoading = false
        })
    },
    //编辑评价等级
    edit(val) {
      this.modelForm.title = '编辑评价等级'
      for (let key in this.modelForm.data) {
        this.modelForm.data[key] = val[key]
      }
      this.modelForm.visible = true
    },
    //删除评价等级
    del(val) {
      this.tableRelevant.tableLoading = true
      this.$http.ReportService.deleteAbilityLevelConfig(val.id)
        .then((res) => {
          const { message } = res
          this.$message.success(message)
          this.getPageList(1)
        })
        .finally(() => {
          this.tableRelevant.tableLoading = false
        })
    },

    //弹出框确认
    modelFormOk() {
      this.$refs.myModelForm.validate((valid) => {
        if (valid) {
          const bool = this.modelForm.title === '添加评价等级'
          const Ajax = bool ? this.$http.ReportService.addAbilityLevelConfig : this.$http.ReportService.updateAbilityLevelConfig
          const form = new FormData()
          for (let key in this.modelForm.data) {
            form.append(key, this.modelForm.data[key])
          }
          form.append('AbilityEvaluationSysId', this.abilitySystemGradeId)
          if (bool) {
            form.delete('id')
          }
          this.modelForm.confirmLoading = true
          Ajax(form)
            .then((res) => {
              const { message } = res
              this.$message.success(message)
              this.modelFormCancel()
              this.getPageList(1)
            })
            .finally(() => {
              this.modelForm.confirmLoading = false
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    //弹出框取消
    modelFormCancel() {
      this.modelForm.visible = false
      this.modelForm.title = '添加评价等级'
      this.modelForm.data = {
        id: undefined,
        abilityLevel: '',
        abilityLevelName: '',
        abilityType: undefined,
        minScore: undefined,
        minScoreIsOpen: 'true',
        maxScore: undefined,
        maxScoreIsOpen: 'true',
        enabled: true,
        description: '',
        levelExpression: '',
      }
    },
  },
}
</script>

<style scoped>
.header {
  margin-bottom: 15px;
}
</style>
